import React, { Component } from 'react';
import { Image, } from 'semantic-ui-react'

class ImageView extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <Image src={this.props.imageObject.imageUrl} size='massive' />
         )
    }
}
 
export default ImageView;


// WEBPACK FOOTER //
// ./src/components/newSite/ImageFinder/ImageView.js